module.exports = __webpack_public_path__ + "static/media/search1.5115f79c.svg";